import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import i18n from './i18n'
import sections from './sections'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    baseUrl: process.env.BASE_URL
  },
  getters: {
    baseUrl: (state) => state.baseUrl
  },
  modules: {
    api,
    i18n,
    sections
  },
  mutations: {},
  actions: {}
})

if (window.STORE) {
  store.replaceState(Object.assign({}, store.state, window.STORE))
}

export default store
